import { useLocation, useNavigate } from "react-router-dom";
import { BottomSheet } from "../../../components/base/BottomSheet";
import Icon from "../../../components/base/Icon";
import { useReportsSideMenuItems } from "./ReportsSideMenu";


interface IProps {
    open: boolean
    onClose: () => void
}

// iOS-style action sheet that slides up from the bottom to switch the active report/segment.
// Replaces the old horizontal pill switcher; triggered by tapping the mobile header title.
export default function ReportsMobileSheet({ open, onClose }: IProps) {

    const items = useReportsSideMenuItems();
    const location = useLocation();
    const navigate = useNavigate();

    const path = location.pathname.toLowerCase();

    const isActive = (link?: string) => !!link && path.startsWith(link.toLowerCase());

    const select = (link?: string) => {
        if (link) navigate(link);
        onClose();
    };

    return (
        <BottomSheet id="reports-segment-sheet" open={open} onClose={onClose}>
            <div className="reports-sheet">
                <div className="fs-4 fw-bolder text-gray-900 text-center mb-4">Reports</div>
                {
                    items.map((m, k) => {
                        if (m.seperator) {
                            return (
                                <div key={`sep-${k}`}
                                    className="text-uppercase fw-bold text-gray-500 fs-8 px-2 mt-4 mb-2">
                                    {m.name}
                                </div>
                            );
                        }

                        const active = isActive(m.link);
                        return (
                            <div key={m.id ?? k}
                                className={"reports-sheet-item d-flex align-items-center px-3 py-3 rounded mb-1 cursor-pointer " + (active ? "bg-light-primary" : "")}
                                onClick={() => select(m.link)}>
                                <span className={"symbol symbol-35px me-3"}>
                                    <span className={"symbol-label " + (active ? "bg-primary" : "bg-light")}>
                                        <Icon icon={m.icon} type="solid" size={15}
                                            className={active ? "text-white" : "text-gray-700"} />
                                    </span>
                                </span>
                                <span className={"fs-5 " + (active ? "fw-bolder text-primary" : "fw-bold text-gray-800")}>
                                    {m.name}
                                </span>
                                {active && <Icon icon="check" type="solid" size={16} className="ms-auto text-primary" />}
                            </div>
                        );
                    })
                }
            </div>
        </BottomSheet>
    );
}
